module.exports = __webpack_public_path__ + "static/media/massive-photos.3ae18fa1.png";